export const messages = {
	en: {
		settings: "Settings",
		selectVoice: "Select Voice",
		selectLanguage: "Select Language",
		voiceSpeed: "Voice Speed",
		theme: "Theme",
		close: "Close",
		editMessage: "Edit Message",
		save: "Save",
		cancel: "Cancel",
		typeMessage: "Type your message...",
		edit: "Edit",
		delete: "Delete",
		send: "Send",
		settingsDialogTitle: "Settings",
		messageInputPlaceholder: "Type your message...",
		messageEditTitle: "Edit Message",
		messageEditSave: "Save",
		messageEditCancel: "Cancel",
		noMessages: "No messages yet.",
		conversations: "Conversations",
		confirmDeletion: "Confirm Deletion",
		confirmDeletionMessage: "Are you sure you want to delete this conversation?",
		renameConversation: "Rename Conversation",
		newName: "New Name",
		rename: "Rename",
		conversationName: "Conversation {number}"
	},
	nl: {
		settings: "Instellingen",
		selectVoice: "Selecteer Stem",
		selectLanguage: "Selecteer Taal",
		voiceSpeed: "Stem Snelheid",
		theme: "Thema",
		close: "Sluiten",
		editMessage: "Bewerk Bericht",
		save: "Opslaan",
		cancel: "Annuleren",
		typeMessage: "Typ je bericht...",
		edit: "Bewerken",
		delete: "Verwijderen",
		send: "Verzenden",
		settingsDialogTitle: "Instellingen",
		messageInputPlaceholder: "Typ je bericht...",
		messageEditTitle: "Bericht Bewerken",
		messageEditSave: "Opslaan",
		messageEditCancel: "Annuleren",
		noMessages: "Nog geen berichten.",
		conversations: "Gesprekken",
		confirmDeletion: "Bevestig Verwijdering",
		confirmDeletionMessage: "Weet je zeker dat je dit gesprek wilt verwijderen?",
		renameConversation: "Hernoem Gesprek",
		newName: "Nieuwe Naam",
		rename: "Hernoem",
		conversationName: "Gesprek {number}"
	},
	es: {
		settings: "Configuraciones",
		selectVoice: "Seleccionar Voz",
		selectLanguage: "Seleccionar Idioma",
		voiceSpeed: "Velocidad de Voz",
		theme: "Tema",
		close: "Cerrar",
		editMessage: "Editar Mensaje",
		save: "Guardar",
		cancel: "Cancelar",
		typeMessage: "Escribe tu mensaje...",
		edit: "Editar",
		delete: "Eliminar",
		send: "Enviar",
		settingsDialogTitle: "Configuraciones",
		messageInputPlaceholder: "Escribe tu mensaje...",
		messageEditTitle: "Editar Mensaje",
		messageEditSave: "Guardar",
		messageEditCancel: "Cancelar",
		noMessages: "Aún no hay mensajes.",
		conversations: "Conversaciones",
		confirmDeletion: "Confirmar Eliminación",
		confirmDeletionMessage: "¿Estás seguro de que deseas eliminar esta conversación?",
		renameConversation: "Renombrar Conversación",
		newName: "Nuevo Nombre",
		rename: "Renombrar",
		conversationName: "Conversación {number}"
	},
	fr: {
		settings: "Paramètres",
		selectVoice: "Sélectionner la Voix",
		selectLanguage: "Sélectionner la Langue",
		voiceSpeed: "Vitesse de la Voix",
		theme: "Thème",
		close: "Fermer",
		editMessage: "Modifier le Message",
		save: "Enregistrer",
		cancel: "Annuler",
		typeMessage: "Tapez votre message...",
		edit: "Modifier",
		delete: "Supprimer",
		send: "Envoyer",
		settingsDialogTitle: "Paramètres",
		messageInputPlaceholder: "Tapez votre message...",
		messageEditTitle: "Modifier le Message",
		messageEditSave: "Enregistrer",
		messageEditCancel: "Annuler",
		noMessages: "Aucun message pour l'instant.",
		conversations: "Conversations",
		confirmDeletion: "Confirmer la Suppression",
		confirmDeletionMessage: "Êtes-vous sûr de vouloir supprimer cette conversation ?",
		renameConversation: "Renommer la Conversation",
		newName: "Nouveau Nom",
		rename: "Renommer",
		conversationName: "Conversation {number}"
	},
	de: {
		settings: "Einstellungen",
		selectVoice: "Stimme auswählen",
		selectLanguage: "Sprache auswählen",
		voiceSpeed: "Stimmgeschwindigkeit",
		theme: "Thema",
		close: "Schließen",
		editMessage: "Nachricht Bearbeiten",
		save: "Speichern",
		cancel: "Abbrechen",
		typeMessage: "Gib deine Nachricht ein...",
		edit: "Bearbeiten",
		delete: "Löschen",
		send: "Senden",
		settingsDialogTitle: "Einstellungen",
		messageInputPlaceholder: "Gib deine Nachricht ein...",
		messageEditTitle: "Nachricht Bearbeiten",
		messageEditSave: "Speichern",
		messageEditCancel: "Abbrechen",
		noMessages: "Noch keine Nachrichten.",
		conversations: "Gespräche",
		confirmDeletion: "Löschung Bestätigen",
		confirmDeletionMessage: "Bist du sicher, dass du dieses Gespräch löschen möchtest?",
		renameConversation: "Gespräch Umbenennen",
		newName: "Neuer Name",
		rename: "Umbenennen",
		conversationName: "Gespräch {number}"
	},
	zh: {
		settings: "设置",
		selectVoice: "选择语音",
		selectLanguage: "选择语言",
		voiceSpeed: "语音速度",
		theme: "主题",
		close: "关闭",
		editMessage: "编辑消息",
		save: "保存",
		cancel: "取消",
		typeMessage: "输入你的消息...",
		edit: "编辑",
		delete: "删除",
		send: "发送",
		settingsDialogTitle: "设置",
		messageInputPlaceholder: "输入你的消息...",
		messageEditTitle: "编辑消息",
		messageEditSave: "保存",
		messageEditCancel: "取消",
		noMessages: "还没有消息。",
		conversations: "会话",
		confirmDeletion: "确认删除",
		confirmDeletionMessage: "您确定要删除此会话吗？",
		renameConversation: "重命名会话",
		newName: "新名称",
		rename: "重命名",
		conversationName: "会话 {number}"
	},
	ja: {
		settings: "設定",
		selectVoice: "音声を選択",
		selectLanguage: "言語を選択",
		voiceSpeed: "音声速度",
		theme: "テーマ",
		close: "閉じる",
		editMessage: "メッセージを編集",
		save: "保存",
		cancel: "キャンセル",
		typeMessage: "メッセージを入力...",
		edit: "編集",
		delete: "削除",
		send: "送信",
		settingsDialogTitle: "設定",
		messageInputPlaceholder: "メッセージを入力...",
		messageEditTitle: "メッセージを編集",
		messageEditSave: "保存",
		messageEditCancel: "キャンセル",
		noMessages: "まだメッセージがありません。",
		conversations: "会話",
		confirmDeletion: "削除を確認",
		confirmDeletionMessage: "この会話を削除してもよろしいですか？",
		renameConversation: "会話の名前を変更",
		newName: "新しい名前",
		rename: "名前を変更",
		conversationName: "会話 {number}"
	},
	ru: {
		settings: "Настройки",
		selectVoice: "Выбрать голос",
		selectLanguage: "Выбрать язык",
		voiceSpeed: "Скорость голоса",
		theme: "Тема",
		close: "Закрыть",
		editMessage: "Редактировать сообщение",
		save: "Сохранить",
		cancel: "Отмена",
		typeMessage: "Введите ваше сообщение...",
		edit: "Редактировать",
		delete: "Удалить",
		send: "Отправить",
		settingsDialogTitle: "Настройки",
		messageInputPlaceholder: "Введите ваше сообщение...",
		messageEditTitle: "Редактировать сообщение",
		messageEditSave: "Сохранить",
		messageEditCancel: "Отмена",
		noMessages: "Пока нет сообщений.",
		conversations: "Разговоры",
		confirmDeletion: "Подтвердить удаление",
		confirmDeletionMessage: "Вы уверены, что хотите удалить этот разговор?",
		renameConversation: "Переименовать разговор",
		newName: "Новое имя",
		rename: "Переименовать",
		conversationName: "Разговор {number}"
	},
	it: {
		settings: "Impostazioni",
		selectVoice: "Seleziona Voce",
		selectLanguage: "Seleziona Lingua",
		voiceSpeed: "Velocità Voce",
		theme: "Tema",
		close: "Chiudi",
		editMessage: "Modifica Messaggio",
		save: "Salva",
		cancel: "Annulla",
		typeMessage: "Digita il tuo messaggio...",
		edit: "Modifica",
		delete: "Elimina",
		send: "Invia",
		settingsDialogTitle: "Impostazioni",
		messageInputPlaceholder: "Digita il tuo messaggio...",
		messageEditTitle: "Modifica Messaggio",
		messageEditSave: "Salva",
		messageEditCancel: "Annulla",
		noMessages: "Ancora nessun messaggio.",
		conversations: "Conversazioni",
		confirmDeletion: "Conferma Eliminazione",
		confirmDeletionMessage: "Sei sicuro di voler eliminare questa conversazione?",
		renameConversation: "Rinomina Conversazione",
		newName: "Nuovo Nome",
		rename: "Rinomina",
		conversationName: "Conversazione {number}"
	},
	pt: {
		settings: "Configurações",
		selectVoice: "Selecionar Voz",
		selectLanguage: "Selecionar Idioma",
		voiceSpeed: "Velocidade da Voz",
		theme: "Tema",
		close: "Fechar",
		editMessage: "Editar Mensagem",
		save: "Salvar",
		cancel: "Cancelar",
		typeMessage: "Digite sua mensagem...",
		edit: "Editar",
		delete: "Excluir",
		send: "Enviar",
		settingsDialogTitle: "Configurações",
		messageInputPlaceholder: "Digite sua mensagem...",
		messageEditTitle: "Editar Mensagem",
		messageEditSave: "Salvar",
		messageEditCancel: "Cancelar",
		noMessages: "Nenhuma mensagem ainda.",
		conversations: "Conversas",
		confirmDeletion: "Confirmar Exclusão",
		confirmDeletionMessage: "Tem certeza de que deseja excluir esta conversa?",
		renameConversation: "Renomear Conversa",
		newName: "Novo Nome",
		rename: "Renomear",
		conversationName: "Conversa {number}"
	}
};